export const ClientType = {
    COMPANY: "ClientType.COMPANY",
    ASSOCIATION: "ClientType.ASSOCIATION",
};